
export default {
	data: state => state.data,
	clients: state => state.clients,
	clientsStatistics: state => state.clientsStatistics,
	clientStatistics: state => state.clientStatistics,
	client: state => state.client,
	meta: state => state.meta,
	clientOrdersMeta: state => state.clientOrdersMeta,
	clientOrdersOldMeta: state => state.clientOrdersOldMeta,
	clientOrdersProductsMeta: state => state.clientOrdersProductsMeta,
	orders: state => state.orders,
	ordersOld: state => state.ordersOld,
	ordersOldMeta: state => state.ordersOldMeta,
	ordersMeta: state => state.ordersMeta,
	editClientForm: state => state.editClientForm,
	loading: state => state.loading,
	searchFilters: state => state.searchFilters,
	ordersSearchFilters: state => state.ordersSearchFilters
}
